// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const {APIPost, APIGet} = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
import { VIEWER } from 'constants/contactCenter/pdfViewer';
// @ helpers
const {downloadAsFile} = require('utilities/APIRequestHelper');
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';
import moment from "moment"
import { DATE_FORMAT_API } from 'constants/index';

import {legalCorrespondenceValue, annualInformationValue, fiscalInformationValue} from 'constants/documents';
import { LEGAL_CORRESPONDENCE, FISCAL_INFORMATION} from 'constants/index';


const requestAdditionalDocumentationInProgress = () => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_REQUEST
});

const requestAdditionalDocumentationSuccess = (data) => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_SUCCESS,
    payload: {
        data
    }
});

const requestAdditionalDocumentationFailure = (error) => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_FAILURE,
    payload: {
        error
    }
});

const requestLegalAdditionalDocumentationSuccess = (data) => ({
    type: actionTypes.FETCH_LEGAL_DOCUMENTATION_SUCCESS,
    payload: {
        data
    }
});

const requestLegalAdditionalDocumentationFailure = (error) => ({
    type: actionTypes.FETCH_LEGAL_DOCUMENTATION_FAILURE,
    payload: {
        error
    }
});

const requestAdditionalDocumentationNoDocuments = (data) => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_NO_DOCUMENTS_SUCCESS,
    payload: {
        data
    }
});

const requestLegalAdditionalDocumentationNoDocuments = (data) => ({
    type: actionTypes.FETCH_LEGAL_DOCUMENTATION_NO_DOCUMENTS_SUCCESS,
    payload: {
        data
    }
});




const requestAditionalDocumentationByDMS = async (dispatch, param) => {
  const applicationByParam = {
    [LEGAL_CORRESPONDENCE]: 'cat_correspondencia',
  };
  let requestData = {
    query: {
      application: applicationByParam[param],
    },
  };
  try {
    const responseDMS = await APIGet(
      dispatch,
      apiURLBuilder.getURL('apiDocumentsDms'),
      requestData
    );
    return { responseDMS };
  } catch (errorDMS) {
    return { errorDMS };
  }
};

const requestAditionalDocumentationBySadde = async (dispatch, param) => {
  const getQueryValue = () => {
    var queryValues = {
      [LEGAL_CORRESPONDENCE]: legalCorrespondenceValue,
      [FISCAL_INFORMATION]: fiscalInformationValue,
      default: annualInformationValue,
    };
    return queryValues[param] || queryValues['default'];
  };
  const requestData = {
    query: [
      {
        name: 'TIPPRODUC',
        operator: 'EQ',
        value: getQueryValue(),
      },
    ],
  };

  try {
    const responseSadde = await APIPost(
      dispatch,
      apiURLBuilder.getURL('requestSaddeDocuments'),
      requestData
    );

    return { responseSadde };
  } catch (errorSadde) {
    return { errorSadde };
  }
};

const isDMSActiveByParam = param => {
  const paramsDMSActiveList = { [LEGAL_CORRESPONDENCE]: true };
  return paramsDMSActiveList[param];
};

const requestAdditionalDocumentation = param => async (dispatch, getState) => {
  const isAlreadyFetching = getState().additionalDocumentation.get('isFetching');
  const isLegalCorrespondence = param === LEGAL_CORRESPONDENCE;
  dispatch(requestAdditionalDocumentationInProgress());

  if (!isAlreadyFetching) {
    try {
      const { responseDMS, errorDMS } = isDMSActiveByParam(param)
        ? await requestAditionalDocumentationByDMS(dispatch, param)
        : {};
      const { responseSadde, errorSadde } = await requestAditionalDocumentationBySadde(
        dispatch,
        param
      );
      if ((responseDMS && responseDMS.documents) || responseSadde) {
        const saddeDocuments = responseSadde || [];
        const dmsDocuments = (responseDMS && responseDMS.documents) || [];
        const dmsDocumentsWithFechaAlta = dmsDocuments.map(document => {
          document.fechaAlta = moment(document.registrationDate).format(DATE_FORMAT_API);
          return document;
        });
        dispatch(
          isLegalCorrespondence
            ? requestLegalAdditionalDocumentationSuccess([
                ...dmsDocumentsWithFechaAlta,
                ...saddeDocuments,
              ])
            : requestAdditionalDocumentationSuccess([
                ...dmsDocumentsWithFechaAlta,
                ...saddeDocuments,
              ])
        );
      } else {
        const saddeDocumentsNotFound =
          errorSadde && errorSadde.body && errorSadde.body.code === '403';
        const dmsDocumentsNotFound = !(responseDMS && responseDMS.documents);
        const documentsNotFound = saddeDocumentsNotFound && dmsDocumentsNotFound;
        documentsNotFound
          ? dispatch(
              isLegalCorrespondence
                ? requestLegalAdditionalDocumentationNoDocuments(true)
                : requestAdditionalDocumentationNoDocuments(true)
            )
          : dispatch(
              isLegalCorrespondence
                ? requestLegalAdditionalDocumentationFailure(errorDMS || errorSadde)
                : requestAdditionalDocumentationFailure(errorDMS || errorSadde)
            );
      }
    } catch (e) {
      dispatch(requestAdditionalDocumentationFailure({ body: {}, error: {}, text: e }));
    }
  }
};

const getSaddePdfDocumentsRequest = process => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_DOWNLOADING_PDF_REQUEST,
    payload: {
        process
    }
});

const getSaddePdfDocumentsFinished = process => ({
    type: actionTypes.FETCH_ADDITIONALDOCUMENTATION_DOWNLOADING_PDF_FINISHED,
    payload: {
        process
    }
});

const getFileSaddeDocuments = (fileParams, filename, loadType) => (dispatch) => {
    const params = {
        query: {
            "process": fileParams.get('process'),
            "internalIdx": fileParams.get('internalIdx'),
            "segmentId": fileParams.get('segmentId'),
            "pageTo": fileParams.get('pageTo'),
            "queryId": fileParams.get('queryId')
        },
        header: {
            responseType: 'arraybuffer'
        }
    };

    dispatch(getSaddePdfDocumentsRequest(fileParams.get('process')));

    return APIGet({
        dispatch,
        params,
        endpoint: 'requestSaddeDocumentsDownload'
    })
        .then(response => {
            if(loadType === VIEWER){
                openPDFViewer(response.xhr.response);
            }else{
                downloadAsFile(response.xhr.response, 'application/pdf', filename + '.pdf');
            }
            dispatch(getSaddePdfDocumentsFinished(fileParams.get('process')));
        })
        .catch(() => {
            if(loadType === VIEWER){
                showPDFFailure();
            }
            dispatch(getSaddePdfDocumentsFinished(fileParams.get('process')))
        });
};

module.exports = {
    requestAdditionalDocumentation,
    getFileSaddeDocuments
};
